const base64UrlEncode = (buffer: ArrayBuffer): string => {
  const bytes = new Uint8Array(buffer);
  let binary = '';
  for (let i = 0; i < bytes.length; i += 1) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary)
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
};

/**
 * Generates a cryptographically random PKCE `code_verifier` (RFC 7636).
 * 32 random bytes Base64URL-encoded yields ~43 characters from the
 * unreserved set, well within the 43–128 length range.
 */
export const generateCodeVerifier = (): string => {
  const randomBytes = new Uint8Array(32);
  crypto.getRandomValues(randomBytes);
  return base64UrlEncode(randomBytes.buffer);
};

/**
 * Derives the PKCE `code_challenge` from a verifier using SHA-256 and
 * Base64URL encoding (the `S256` method).
 */
export const generateCodeChallenge = async (
  codeVerifier: string,
): Promise<string> => {
  const data = new TextEncoder().encode(codeVerifier);
  const digest = await crypto.subtle.digest('SHA-256', data);
  return base64UrlEncode(digest);
};
